import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appParameterSpec: {},
    refreshIntervallHandler: "",
    isUploading: false,
    roles: [],
    user: null,
    hospital: null,
    surgeon: null,
    facility: null
  },
  mutations: {
    SET_APP_PARAMETER_SPEC_TTK: (state, spec) => {
      state.appParametersSpecTTK = spec
    },
    SET_APP_PARAMETER_SPEC: (state, spec) => {
      state.appParameterSpec = spec
    },
    SET_REFRESH_INTERVAL_HANDLER: (state, handler) => {
      state.refreshIntervallHandler = handler
    },
    SET_IS_UPLOADING: (state, isUploading) => {
      state.isUploading = isUploading
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USER_TO_EDIT: (state, user) => {
      state.user = user
    },
    SET_HOSPITAL_TO_EDIT: (state, hospital) => {
      state.hospital = hospital
    },
    SET_SURGEON_TO_EDIT: (state, surgeon) => {
      state.surgeon = surgeon
    },
    SET_FACILITY_TO_EDIT: (state, facility) => {
      state.facility = facility
    }
  },
  actions: {
  },
  getters: {
    getProcedureText: state => procedure => {
      return state.appParameterSpec[procedure]["Text"]
    },
    getRoles: state => {
      return state.roles;
    },
    /**
     * returns list of all available implant data per selected procedure
     * @param {*} procedure currently selected procedure
     * @returns available implant Data
     */
    implantData: state => procedure => {
      let implantData = []
      for (let data in state.appParameterSpec[procedure]["ImplantData"]) {
        implantData.push({ "value": data, "text": state.appParameterSpec[procedure]["ImplantData"][data]["Text"] })
      }
      return implantData
    },
    /**
     * returns a list of all available procedures with their display label
     * @returns list of all available procedures with their display label
     */
    procedureList: state => {
      let procedureList = []
      for (let proc in state.appParameterSpec) {
        procedureList.push({ "value": proc, "text": state.appParameterSpec[proc]["Text"] })
      }
      return procedureList
    },
    /**
     * returns a list of all params labels for the selected procedure
     * @param {*} procedure currently selected procedure
     * @returns list of all params labels for the selected procedure
     */
    paramLabels: state => procedure => {
      const params = state.appParameterSpec[procedure]["Parameters"]
      const paramLabels = params.map(param => Object.values(param)[0]["Text"])
      return paramLabels
    },
    /**
     * returns all available first parameters for the selected procedure
     * @param {*} procedure currently selected procedure
     * @returns available first parameters
     */
    firstParamList: state => (procedure) => {
      let firstParamList = []
      const itemList = Object.values(state.appParameterSpec[procedure]["Parameters"][0])[0]["Items"]
      for (let item in itemList) {
        firstParamList.push({ "value": item, "text": itemList[item]["Text"] })
      }
      return firstParamList
    },
    /**
     * returns all available second parameters for the selected procedure and the selected first param
     * @param {*} procedure currently selected procedure
     * @returns available second parameters
     */
    secondParamList: state => (procedure, selectedFirstParam) => {
      let secondParamList = []
      const itemList = Object.values(state.appParameterSpec[procedure]["Parameters"][1])[0]["Items"]
      // get all validCombinations with selectedFirst param in first slot
      let validCombinations = state.appParameterSpec[procedure]["ValidCombinations"]
        .filter(comb => comb[0] === selectedFirstParam)
      // Loop itemList to check which items are valid for the current selection
      for (let item in itemList) {
        // If validCombinations contains item in second slot
        if (validCombinations.some(comb => comb[1] === item)) {
          secondParamList.push({ "value": item, "text": itemList[item]["Text"] })
        }
      }
      return secondParamList
    },
    /**
     * returns all available third parameters for the selected procedure and the selected first param
     * @param {*} procedure currently selected procedure
     * @returns available third parameters
     */
    thirdParamList: state => (procedure, selectedFirstParam, selectedSecondParam) => {
      let thirdParamList = []
      const itemList = Object.values(state.appParameterSpec[procedure]["Parameters"][2])[0]["Items"]
      // get all validCombinations with selectedFirst param in first slot
      let validCombinations = state.appParameterSpec[procedure]["ValidCombinations"]
        .filter(comb => {
          return comb[0] === selectedFirstParam && comb[1] === selectedSecondParam
        })
      // Loop itemList to check which items are valid for the current selection
      for (let item in itemList) {
        // If validCombinations contains item in third slot
        if (validCombinations.some(comb => comb[2] === item)) {
          thirdParamList.push({ "value": item, "text": itemList[item]["Text"] })
        }
      }
      return thirdParamList
    }
  }
})
